module.exports = __webpack_public_path__ + "media/images/athletes/291-8a13362a6c4075bfe5a93f7d5b53d967.png";